<div class="app-wrapper top-bar">
    <main>
        <div class="container-fluid px-2 px-md-4 px-lg-5 py-4 py-xl-5">
            <div class="content-container">
                <h1>App Dashboard</h1>
            </div>
        </div>
    </main>
</div>
